import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const V2FinancialAccountsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "v2FinancialAccounts" */
      '../../../components/MoneyManagement/V2FinancialAccounts'
    ),
  releaseState: 'internal',
  enabledKey: 'internal',
  teamOwner: 'platform-surfaces',
  sentryTeam: 'platform_surfaces_embedded',
  description: 'Displays the list of V2 financial accounts.',
  friendlyName: 'V2 financial accounts',
  enableV2APIToken: true,
};
